export function canUseLiveCamera() {
  return (
    typeof window !== 'undefined' &&
    window.isSecureContext &&
    typeof navigator !== 'undefined' &&
    navigator.mediaDevices &&
    typeof navigator.mediaDevices.getUserMedia === 'function'
  );
}

export function isInsecureHttpOrigin() {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'http:' && !window.isSecureContext;
}

export function getLiveCameraBlockReason() {
  if (typeof window === 'undefined') return null;
  if (!navigator.mediaDevices?.getUserMedia) {
    return 'เบราว์เซอร์ไม่รองรับกล้อง';
  }
  if (!window.isSecureContext) {
    return 'http://IP ถูกบล็อก live camera — ต้อง whitelist ใน Chrome (ดูด้านล่าง)';
  }
  return null;
}

export function getCurrentOrigin() {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

export function isSafariBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return isIOS || isSafari;
}

export function isIOSDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}
